export default {
    darkBlue: "#0042b8",
    lightBlue: "#52B3D8",
    lightBlueHover: "#3FA6CD",
    green: "#9BC940",
    red: "#D43D60",
    lightGray: "#F1F3F5",
    black: "#000000",
}